export const RQ_SUPERVISOR_UPDATE = {
  url: 'api/supervisor/update/<%= id %>',
  method: 'PUT',
  auth: true,
};

export const RQ_EMPLOYEE_UPDATE_ALL_FIELDS = {
  url: 'api/employee/<%= id %>/update/allfields',
  method: 'PUT',
  auth: true,
};

export const RQ_EMPLOYEE_RESET_PASSWORD = {
  url: 'api/employee/reset-password',
  method: 'PUT',
  auth: false,
};

export const RQ_EMPLOYEE_FORGOT_PASSWORD = {
  url: 'api/employee/forgot-password',
  method: 'PUT',
  auth: false,
};

export const RQ_ADMIN_UPDATE_ROLE = {
  url: 'api/admin/update/<%= role %>/<%= id %>',
  method: 'PUT',
  auth: true,
};

export const RQ_ACCOUNTANT_UPDATE = {
  url: 'api/accountant/update/<%= id %>',
  method: 'PUT',
  auth: true,
};

export const RQ_USER_LOGIN = {
  url: 'api/user/login',
  method: 'POST',
  auth: false,
};

export const RQ_SUPERVISOR_REGISTER = {
  url: 'api/supervisor/register/<%= role %>',
  method: 'POST',
  auth: true,
};

export const RQ_EMPLOYEE_REGISTER = {
  url: 'api/employee/register',
  method: 'POST',
  auth: false,
};

export const RQ_ADMIN_REGISTER = {
  url: 'api/admin/register',
  method: 'POST',
  auth: true,
};

export const RQ_ADMIN_REGISTER_ROLE = {
  url: 'api/admin/register/<%= role %>',
  method: 'POST',
  auth: true,
};

export const RQ_ACCOUNTANT_REGISTER = {
  url: 'api/accountant/register/<%= role %>',
  method: 'POST',
  auth: true,
};

export const RQ_SUPERVISOR_LOOKUP_ALL = {
  url: 'api/supervisor/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_EMPLOYEE_LOOKUP_ID = {
  url: 'api/user/lookup/<%= id %>',
  method: 'GET',
  auth: true,
};

export const RQ_EMPLOYEE_LOOKUP_STATUS = {
  url: 'api/employee/lookup/status',
  method: 'GET',
  auth: true,
};

export const RQ_EMPLOYEE_LOOKUP_ALL = {
  url: 'api/supervisor/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_EMPLOYEE_LOOKUP_ALL_ACTIVE = {
  url: 'api/employee/lookup/all/active',
  method: 'GET',
  auth: true,
};

export const RQ_ADMIN_LOOKUP_ALL = {
  url: 'api/admin/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_ADMIN_LOOKUP_ALL_ROLE = {
  url: 'api/admin/lookup/all/<%= role %>',
  method: 'GET',
  auth: true,
};

export const RQ_ADMIN_FILTER = {
  url: 'api/admin/filter',
  method: 'GET',
  auth: true,
};

export const RQ_ACCOUNTANT_LOOKUP_ALL = {
  url: 'api/accountant/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_DELETE_USER = {
  url: 'api/user/delete/<%= id %>',
  method: 'DELETE',
  auth: true,
};
